var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('main',{staticClass:"main-container",class:{ 'no-padding': this.$route.meta.isNotPadding }},[_c('router-view')],1),_c('Notications'),_c('DialogComponent'),(this.$route.meta.isShowMenu)?_c('Navigation'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }